import React, { useEffect } from 'react';
import { Field, useFormikContext } from 'formik';
import * as yup from 'yup';

import { ComboBox, TextInput } from '@components';

export const opcoesMotivoRetiradaPesquisaTendencia = [
  {
    id: 'Consumo imediato',
    name: 'Consumo imediato (compra de imóvel, estudos, viagens, etc.)',
  },
  { id: 'Quitar dívidas', name: 'Quitar dívidas' },
  {
    id: 'Investir em um negócio',
    name: 'Investir em um negócio (Empreender)',
  },
  {
    id: 'Investir no mercado financeiro por conta própria',
    name: 'Investir no mercado financeiro por conta própria',
  },
  {
    id: 'Investir em outra instituição',
    name: 'Investir em outra instituição',
  },
  {
    id: 'Preocupação com o futuro da Forluz',
    name: 'Preocupação com o futuro da Forluz',
  },
  { id: 'Outros', name: 'Outros' },
];

export const pesquisaTendenciaInitialValues = {
  motivo_temp: '',
  instituicao_temp: '',
  outro_temp: '',
  pesquisaTendencia: '',
};

export const pesquisaTendenciaSchema = yup.object({
  motivo_temp: yup
    .string()
    .oneOf(opcoesMotivoRetiradaPesquisaTendencia.map((o) => o.id))
    .required('Atenção, selecione o motivo.'),
  instituicao_temp: yup.string().when('motivo_temp', {
    is: 'Investir em outra instituição',
    then: (field) => field.trim().required('Atenção, informe a instituição.'),
    otherwise: (field) => field.notRequired().nullable(),
  }),
  outro_temp: yup.string().when('motivo_temp', {
    is: 'Outros',
    then: (field) => field.trim().required('Atenção, especifique.'),
    otherwise: (field) => field.notRequired().nullable(),
  }),
  pesquisaTendencia: yup.string().required('Atenção, responda o questionário.'),
});

export const PesquisaTendencia = () => {
  const { values, setFieldValue } = useFormikContext();

  const motivo = values.motivo_temp;
  const instituicao = values.instituicao_temp;
  const outro = values.outro_temp;

  useEffect(() => {
    if (!motivo) {
      setFieldValue('pesquisaTendencia', '', true);
      return;
    }

    const precisaDeInstituicao = motivo === 'Investir em outra instituição';
    const precisaDeOutro = motivo === 'Outros';

    if (precisaDeInstituicao || precisaDeOutro) {
      const valorExtra = precisaDeInstituicao ? instituicao : outro;

      if (!valorExtra?.trim()) {
        setFieldValue('pesquisaTendencia', '', true);
        return;
      }

      setFieldValue('pesquisaTendencia', `${motivo}: ${valorExtra}`, true);
      return;
    }

    setFieldValue('pesquisaTendencia', motivo, true);
  }, [motivo, instituicao, outro, setFieldValue]);

  return (
    <>
      <div className="row">
        <div className="col-md-12 col-lg-6">
          <Field
            className="mb-3"
            name="motivo_temp"
            component={ComboBox}
            options={opcoesMotivoRetiradaPesquisaTendencia.map((opcao) => {
              return { value: opcao.id, label: opcao.name };
            })}
            label="Por qual motivo você está retirando os recursos da Forluz?"
          />
        </div>
      </div>

      {motivo === 'Investir em outra instituição' && (
        <div className="row">
          <div className="col-md-12 col-lg-6">
            <Field
              className="mb-3"
              name="instituicao_temp"
              component={TextInput}
              label="Qual instituição?"
              autoComplete="off"
            />
          </div>
        </div>
      )}

      {motivo === 'Outros' && (
        <div className="row">
          <div className="col-md-12 col-lg-6">
            <Field
              className="mb-3"
              name="outro_temp"
              component={TextInput}
              label="Especifique:"
              autoComplete="off"
            />
          </div>
        </div>
      )}
    </>
  );
};
